var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0ZM6.0011 10.353H8.83387V18.8643H6.0011V10.353ZM9.02049 7.72004C9.00211 6.88551 8.40533 6.24989 7.43626 6.24989C6.46719 6.24989 5.83364 6.88551 5.83364 7.72004C5.83364 8.53728 6.44846 9.19121 7.39949 9.19121H7.41759C8.40533 9.19121 9.02049 8.53728 9.02049 7.72004ZM15.7882 10.1533C17.6523 10.1533 19.0498 11.37 19.0498 13.9843L19.0497 18.8644H16.217V14.3109C16.217 13.1671 15.8071 12.3867 14.7816 12.3867C13.999 12.3867 13.5329 12.9128 13.3281 13.421C13.2532 13.6031 13.2348 13.8569 13.2348 14.1113V18.8647H10.4017C10.4017 18.8647 10.4391 11.152 10.4017 10.3534H13.2348V11.5589C13.6108 10.9794 14.2842 10.1533 15.7882 10.1533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1bf089132efced25463ac536d82720a5.svg";
export { ForwardRef as ReactComponent };